import styled from "styled-components";
import {
  colors,
  getTypographyFontStyle,
  device,
} from "../../styles/global.style";

const IconCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  padding-bottom: 16px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.14);
  }
`;

const Icon = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  margin: 0;
  padding: 0;

  @media ${device.md} {
    height: 250px;
  }
`;

const IconDescription = styled.p`
  ${getTypographyFontStyle({ variant: "body1", weight: 400 })}
  font-size: 13px;
  color: ${colors.lightdark};
  text-align: center;
  padding: 0 16px;
  line-height: 1.6;

  @media ${device.md} {
    font-size: 15px;
    padding: 0 20px;
    max-width: 600px;
  }
`;

export { IconCardContainer, Icon, IconDescription };
